webpackJsonp([70918135257325,206583366516095,180758181376175,153518715421262,108875553959277,253376983384479],{

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Export;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _assets = __webpack_require__(80);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Export() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'xs', sizeM: 'l', type: 'padding', position: 'topBottom' },
	    _react2.default.createElement(
	      _maxWidth2.default,
	      { value: 720 },
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 2, size: 'l', alignItems: 'center', justifyContent: 'center' },
	        _react2.default.createElement(
	          _grid.GridItem,
	          null,
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', type: 'padding', position: 'topBottom' },
	            _react2.default.createElement(_Image2.default, _assets2.default.generateApp)
	          )
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 2, columnSpanM: 1 },
	          _react2.default.createElement(
	            _align2.default,
	            { type: 'center', typeM: 'left' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 's', type: 'padding', position: 'topBottom' },
	              _react2.default.createElement(
	                _heading2.default,
	                { tag: 'h2', weight: 'semibold', size: 'l' },
	                'One click app export'
	              )
	            ),
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'slate' },
	              'Once you\u2019ve finished your prototype, click Download and we\u2019ll package it up as an Android app (.apk) using our Android App Maker.'
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Images;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _assets = __webpack_require__(80);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Images() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'xs', sizeM: 'l', type: 'padding', position: 'topBottom' },
	    _react2.default.createElement(
	      _maxWidth2.default,
	      { value: 720 },
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 2, size: 'l', alignItems: 'center', justifyContent: 'center' },
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 2, columnSpanM: 1 },
	          _react2.default.createElement(
	            _align2.default,
	            { type: 'center', typeM: 'left' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 's', type: 'padding', position: 'topBottom' },
	              _react2.default.createElement(
	                _heading2.default,
	                { tag: 'h2', weight: 'semibold', size: 'xl' },
	                'Create a prototype using images'
	              )
	            ),
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'slate' },
	              'Add your app designs or sketches to Marvel and form your prototype. We support PSD, JPG, PNG, GIF and Sketch.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          null,
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', type: 'padding', position: 'topBottom' },
	            _react2.default.createElement(_Image2.default, _assets2.default.imageFiles)
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1254:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = AndroidAppBuilder;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _IntegrationsCta = __webpack_require__(118);
	
	var _IntegrationsCta2 = _interopRequireDefault(_IntegrationsCta);
	
	var _Whitespace = __webpack_require__(35);
	
	var _Whitespace2 = _interopRequireDefault(_Whitespace);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _assets = __webpack_require__(80);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _images = __webpack_require__(631);
	
	var _images2 = _interopRequireDefault(_images);
	
	var _export = __webpack_require__(630);
	
	var _export2 = _interopRequireDefault(_export);
	
	var _integrate = __webpack_require__(632);
	
	var _integrate2 = _interopRequireDefault(_integrate);
	
	var _questions = __webpack_require__(633);
	
	var _questions2 = _interopRequireDefault(_questions);
	
	var _share = __webpack_require__(634);
	
	var _share2 = _interopRequireDefault(_share);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AndroidAppBuilder() {
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: 'Android App Builder | Marvel',
	      meta: [{
	        name: 'description',
	        content: 'Make and build Android apps from images, sketches and designs. No coding required. Just click download and we’ll package it up using our Android App Maker.'
	      }, {
	        name: 'keywords',
	        content: 'android app builder, app maker, apk maker, prototype to apk, build apps'
	      }],
	      header: true,
	      footer: true
	    },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      { size: 'l' },
	      _react2.default.createElement(_Whitespace2.default, { size: 's', sizeS: 'l', sizeM: 'xl' }),
	      _react2.default.createElement(
	        _align2.default,
	        { type: 'center' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 's', type: 'padding', position: 'bottom' },
	          _react2.default.createElement(_Image2.default, _assets2.default.illustration)
	        ),
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 720 },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h1', weight: 'semibold', size: 'mega' },
	            'Turn your prototypes into Android Apps'
	          )
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 's', type: 'padding', position: 'topBottom' },
	          _react2.default.createElement(
	            _maxWidth2.default,
	            { value: 720 },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'xxxl', color: 'slate' },
	              'Upgrade to Marvel Pro and export prototypes into offline Android apps (.apk) with no coding involved. Requires Lollipop 5.0+, available on Marvel Pro, Company, and Enterprise plans.',
	              ' ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/pricing' },
	                _react2.default.createElement(
	                  _link2.default,
	                  { type: 'blue' },
	                  'Click here'
	                )
	              ),
	              ' ',
	              'for more info.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 's', type: 'padding', position: 'top' },
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', type: 'padding', position: 'bottom' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/signup' },
	              _react2.default.createElement(
	                _button2.default,
	                { size: 'large', shape: 'rounded', hover: 'blue' },
	                'Start prototyping'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_images2.default, null),
	        _react2.default.createElement(_export2.default, null),
	        _react2.default.createElement(_share2.default, null),
	        _react2.default.createElement(_integrate2.default, null),
	        _react2.default.createElement(_questions2.default, null)
	      )
	    ),
	    _react2.default.createElement(_IntegrationsCta2.default, null)
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Integrate;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _assets = __webpack_require__(80);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Integrate() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'xs', sizeM: 'l', type: 'padding', position: 'topBottom' },
	    _react2.default.createElement(
	      _maxWidth2.default,
	      { value: 720 },
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 2, size: 'l', alignItems: 'center', justifyContent: 'center' },
	        _react2.default.createElement(
	          _grid.GridItem,
	          null,
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', type: 'padding', position: 'topBottom' },
	            _react2.default.createElement(_Image2.default, _assets2.default.logosRetina)
	          )
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 2, columnSpanM: 1 },
	          _react2.default.createElement(
	            _align2.default,
	            { type: 'center', typeM: 'left' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 's', type: 'padding', position: 'topBottom' },
	              _react2.default.createElement(
	                _heading2.default,
	                { tag: 'h2', weight: 'semibold', size: 'xl' },
	                'Take it further'
	              )
	            ),
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'slate' },
	              'You can link your prototype to any website or piece of content including surveys on Typeform or Survey Monkey. You can even publish it to the Play Store'
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Questions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var questions = [{
	  id: 1,
	  name: '​Do the apps work offline?',
	  answer: "​Yes! We package up your prototype as an app (.apk) so once ​it's installed it'll run without an internet connection."
	}, {
	  id: 2,
	  name: '​Can I put the app in the Play Store?',
	  answer: 'Yes! You can turn a bunch of sketches or designs into something you can validate and test for real.'
	}, {
	  id: 3,
	  name: '​Does Marvel export reusable code?',
	  answer: "​The app we generate still contains your designs as images, it's not something you would give to a developer."
	}, {
	  id: 4,
	  name: '​How much does it cost?',
	  answer: '​Marvel Pro starts at $12 per month, per person.'
	}];
	
	var items = questions.map(function (question) {
	  return _react2.default.createElement(
	    _grid.GridItem,
	    { columnSpan: 2, columnSpanM: 1, key: question.id },
	    _react2.default.createElement(
	      _align2.default,
	      { type: 'center', typeM: 'left' },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 's', type: 'padding', position: 'topBottom' },
	        _react2.default.createElement(
	          _heading2.default,
	          { tag: 'h3', weight: 'semibold', size: 'l' },
	          question.name
	        )
	      ),
	      _react2.default.createElement(
	        _paragraph2.default,
	        { size: 'm', color: 'slate' },
	        question.answer
	      )
	    )
	  );
	});
	
	function Questions() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'xl', type: 'padding', position: 'topBottom' },
	    _react2.default.createElement(
	      _maxWidth2.default,
	      { value: 720 },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'xl', type: 'padding', position: 'bottom' },
	        _react2.default.createElement(
	          _heading2.default,
	          { tag: 'h2', weight: 'semibold', size: 'xl' },
	          'Common questions'
	        )
	      ),
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 2, size: 'l' },
	        items
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Share;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(18);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _assets = __webpack_require__(80);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Share() {
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'xs', sizeM: 'l', type: 'padding', position: 'topBottom' },
	    _react2.default.createElement(
	      _maxWidth2.default,
	      { value: 720 },
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 2, size: 'l', alignItems: 'center', justifyContent: 'center' },
	        _react2.default.createElement(_reactResponsive2.default, { maxWidth: 1200 }),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 2, columnSpanM: 1 },
	          _react2.default.createElement(
	            _align2.default,
	            { type: 'center', typeM: 'left' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 's', type: 'padding', position: 'topBottom' },
	              _react2.default.createElement(
	                _heading2.default,
	                { tag: 'h2', weight: 'semibold', size: 'xl' },
	                'Share the download link'
	              )
	            ),
	            _react2.default.createElement(
	              _paragraph2.default,
	              { size: 'l', color: 'slate' },
	              'Marvel will automatically generate a download page for your Android app build. Simply send the link to your device and install.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          null,
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', type: 'padding', position: 'topBottom' },
	            _react2.default.createElement(_Image2.default, _assets2.default.devicesRetina)
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-android-app-builder-index-js-4adec836dc0ff48b0351.js